import AdminIcon from './icons/AdminIcon.svg'
import biodiversityCircle from './biodiversityCircle.svg'
import Camera from './icons/Camera.svg'
import CHINA from './flags/cn.png'
import ClimatetradeForDevelopers from './climatetradeForDevelopers.svg'
import Compensated from './icons/Compensated.svg'
import compensationCircle from './compensationCircle.png'
import contributionCircle from './contributionCircle.png'
import Dashboard from './icons/Dashboard.svg'
import dashboardBlue from './icons/dashboardBlue.svg'
import Developers from './icons/sidebar-developers.svg'
import DownloadIcon from './icons/DownloadIcon.svg'
import Email from './icons/Email.svg'
import EmailBlue from './icons/EmailBlue.svg'
import energyCircle from './energyCircle.png'
import FRANCE from './flags/fr.png'
import GERMANY from './flags/de.png'
import ITALY from './flags/it.png'
import KOREA from './flags/kr.png'
import Location from './icons/location.svg'
import MyFootPrint from './icons/my-footprint.svg'
import Notifications from './icons/Notifications.svg'
import NotificationsBlue from './icons/NotificationsBlue.svg'
import Offer from './icons/Offer.svg'
import OfferBlue from './icons/OfferBlue.svg'
import PlusIcon from './icons/plusIcon.svg'
import POLAND from './flags/pl.png'
import PORTUGAL from './flags/pt.png'
import PremiumCalculator from './icons/PremiumCalculator.svg'
import ProgressIndicator from './icons/progress-indicator.gif'
import Project from './icons/Project.svg'
import projectBlue from './icons/projectBlue.svg'
import Projects from './icons/Projects.svg'
import Publications from './icons/Publications.svg'
import RegisterBackground from './register-background.jpeg'
import RegisterComplete from './RegisterComplete.svg'
import Settings from './icons/Settings.svg'
import SPAIN from './flags/es.png'
import Transactions from './icons/Transactions.svg'
import USA from './flags/us.png'
import Users from './icons/Users.svg'
import AlgorandLogo from './Algorand_logo.svg'

export {
  AdminIcon,
  AlgorandLogo,
  biodiversityCircle,
  Camera,
  CHINA,
  ClimatetradeForDevelopers,
  Compensated,
  compensationCircle,
  contributionCircle,
  Dashboard,
  dashboardBlue,
  Developers,
  DownloadIcon,
  Email,
  EmailBlue,
  energyCircle,
  FRANCE,
  GERMANY,
  ITALY,
  KOREA,
  Location,
  MyFootPrint,
  Notifications,
  NotificationsBlue,
  Offer,
  OfferBlue,
  PlusIcon,
  POLAND,
  PORTUGAL,
  PremiumCalculator,
  ProgressIndicator,
  Project,
  projectBlue,
  Projects,
  Publications,
  RegisterBackground,
  RegisterComplete,
  Settings,
  SPAIN,
  Transactions,
  USA,
  Users,
}
